/**
 * Launch SEO strings live here so Console-hosted translations cannot overwrite
 * unique titles/meta on TEST. Do not hire SEO agencies or invent rankings.
 */

export const landingSchemaTitle = marketplaceName =>
  `Talk it out with a real person, first 15 min free | ${marketplaceName}`;

export const landingSchemaDescription =
  'Find someone to talk to. Talk it out by text, voice or video; each listener sets their own prices. Your first 15 minutes are free.';

export const searchSchemaDescription =
  'Search online listeners and Sweet Skillz teachers for a 15-minute conversation by text, voice or video. Each listener sets their own prices. Search by topic.';

export const searchKeywordsFromParams = searchParams => {
  if (typeof searchParams?.keywords !== 'string') {
    return '';
  }
  return searchParams.keywords.trim();
};

/**
 * Search titles use keywords only. Address/city must never appear — we do not
 * ship location landing pages.
 */
export const formatSearchSchemaTitle = (marketplaceName, searchParams) => {
  const keywords = searchKeywordsFromParams(searchParams);
  if (keywords) {
    return `Listener for “${keywords}” | ${marketplaceName}`;
  }
  return `Find a listener | ${marketplaceName}`;
};

export const formatListingSchemaTitle = ({ title, marketplaceName }) =>
  `${title} — online listener | ${marketplaceName}`;

export const formatListingSchemaDescription = ({ title }) =>
  `Book a 15-minute session with ${title}. Text, voice or video at their own prices. An online listener.`;

/**
 * Listener profile structured data. Person.name is the screen name only.
 * Service describes the paid listening conversation, not therapy.
 */
export const formatListingProfileSchema = ({ screenName, description, url, images }) => {
  const person = {
    '@type': 'Person',
    name: screenName,
    description,
    url,
    ...(images?.length ? { image: images } : {}),
  };
  return [
    {
      '@type': 'ProfilePage',
      name: screenName,
      description,
      url,
      mainEntity: person,
    },
    {
      '@type': 'Service',
      name: `Online listening session with ${screenName}`,
      description,
      url,
      serviceType: 'Online listening conversation',
      provider: person,
    },
  ];
};

export const faqSchemaTitle = marketplaceName =>
  `FAQ: sessions, prices, safety | ${marketplaceName}`;

export const faqSchemaDescription =
  'Answers about 15-minute sessions, listener-set prices, 18+ safety, and how booking works. Your first 15 minutes are free.';

export const termsSchemaTitle = marketplaceName =>
  `Terms for talkers and listeners | ${marketplaceName}`;

export const termsSchemaDescription =
  'The rules for using Sweet Listeners: 18+ only, on-platform conversations, Stripe payments, and no personal-info exchange. Read before you book or listen.';

export const privacySchemaTitle = marketplaceName =>
  `How we protect your privacy | ${marketplaceName}`;

export const privacySchemaDescription =
  'What we collect, how we use it, and what stays on Sweet Listeners. We do not sell your personal information. Sessions stay on-platform.';

export const contactSchemaTitle = marketplaceName =>
  `Write us — we write back | ${marketplaceName}`;

export const contactSchemaDescription =
  'Email info@sweetlisteners.com about bookings, listener payouts, safety, or tech help. We reply within one business day.';
